export interface AppConfig {
  stage: string;
  apiUrl: string;
  websocketApiUrl: string;
  graphqlApiUrl: string;
  cognito: {
    userPoolId: string;
    userPoolClientId: string;
    identityPoolId: string;
  };
  assetsBucket: string;
  domain: string;
  operationManualUrl: string;
  serviceAgreementUrl: string;
}

let config: AppConfig | null = null;

export const configService = {
  async loadConfig(): Promise<AppConfig> {
    if (config) return config;
    
    try {
      const response = await fetch('/config/config.json');
      if (!response.ok) {
        throw new Error(`設定ファイルの読み込みに失敗しました: ${response.status}`);
      }
      
      const loadedConfig = await response.json();
      config = loadedConfig;
      return loadedConfig;
    } catch (error) {
      console.error('設定ファイルの読み込みエラー:', error);
      // デフォルト設定を返す（実際の実装では適切なデフォルト値を設定する）
      const defaultConfig: AppConfig = {
        stage: 'dev',
        apiUrl: '',
        websocketApiUrl: '',
        graphqlApiUrl: '',
        cognito: {
          userPoolId: '',
          userPoolClientId: '',
          identityPoolId: ''
        },
        assetsBucket: '',
        domain: '',
        operationManualUrl: '/docs/sst_operation_manual_ver4.2.pdf',
        serviceAgreementUrl: '/docs/sst_service_agreement_v2.pdf'
      };
      
      config = defaultConfig;
      return defaultConfig;
    }
  },
  
  getConfig(): AppConfig {
    if (!config) {
      throw new Error('設定が読み込まれていません。先にloadConfig()を呼び出してください。');
    }
    return config;
  }
};
